<template>
    <div class="text-center">
        <div class="font-16 font-weight" v-if="excelstatus == 0 || excelstatus == 1 ">处理中...</div>
        <div class="margin-top-10">小贴士：当前操作系统处理中，如不想在本页面等待处理结果，可关闭提示，关闭后可在<span class="font-14 color-error">右上角铃铛的任务标签</span>查看最新状态，处理完成也可以通过<span class="font-14 color-error">右上角铃铛的任务标签</span>进行文件下载</div>
        <div class="margin-top-10 margin-bottom-10 font-14 font-weight">如继续等待请保持窗口打开，请稍后...</div>
        <div class="margin-top-10 margin-bottom-10 font-14 font-weight" v-if="excelstatus == 2 ">
            处理完成！<a v-if="downurl" class="margin-top-10 font-16" style="text-decoration:underline" @click="dowmExcel">点击下载</a>
            <span v-else>无数据</span>
        </div>
        <div class="margin-top-10 margin-bottom-10 font-14 font-weight" v-if="excelstatus == 3 ">
            处理失败！请到<span class="font-14 color-error">右上角铃铛的任务标签</span>查看详情
        </div>

        <div class="text-right">
            <vButton @click="close">关闭</vButton>
        </div>
    </div>
</template>

<script>
import { HttpReportTaskCenter } from "@/service/newbigaccount";
export default {
    props:['fileId'],
    data(){
        return {
            count:5,
            excelstatus: 1,
            downurl: '',
            taskid: this.fileId || '',
            showAlert:true,
        }
    },
    created(){
        this.countDown();
    },
    methods:{
        close(){
            this.showAlert = false;
            this.$emit('on-close')
        },
        countDown(){
            setTimeout(()=>{
                if(this.count>1){
                    this.countDown()
                }else{
                    this.getOneTask()
                }
                this.count --;
            },1000)
        },
        getOneTask(){
            HttpReportTaskCenter({
                id:this.taskid
            }).then(res=>{
                this.excelstatus = res.data.status
                if((this.excelstatus == 0 || this.excelstatus == 1 ) && this.showAlert){
                    this.count = 5;
                    this.countDown();
                    return
                }
                this.downurl = res.data.attachUrl
            })
        },
        dowmExcel(url){
            // event.preventDefault();
            this.handleWebfs(this.downurl, {}, 'download')
        }
    }
}
</script>
